<template>
  <v-select
    :menu-props='{auto: true}'
    :prepend-icon='prependIcon'
    :label='label'
    :hide-details='!hint && !required'
    :hint='hint'
    :persistent-hint='persistentHint'
    :disabled='disabled'
    :items='time'
    v-model='val'
    :rules='required ? [rules.required] : []'
    :append-outer-icon='clearable && !readonly ? "mdi-close" : null'
    @click:append-outer='val = null'
    @change='$emit("change")'
    :filled='filled'
    :readonly='readonly'
  ></v-select>
</template>

<script>
import formRules from '@/mixins/formRules'
import miscServices from '@/services/misc'

export default {
  name: 'wc-timepicker',
  mixins: [formRules],
  props: {
    value: {
      required: true
    },
    label: {
      required: false,
      default: 'Time'
    },
    start: {
      required: false,
      default: 0
    },
    end: {
      required: false,
      default: 24
    },
    increment: {
      required: false,
      default: 5
    },
    prependIcon: {
      required: false,
      default: 'mdi-clock-outline'
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    hint: {
      type: String,
      required: false,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    persistentHint: {
      required: false,
      type: Boolean,
      default: false
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false
    },
    filled: {
      // currently used to indicate readonly status of an input (styling started on tasks - MJ)
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      time: [],
      val: null
    }
  },
  mounted () {
    this.time = miscServices.buildTimes(this.start, this.end, this.increment)
    this.val = this.value
    this.updateTime()
  },
  watch: {
    val () {
      this.updateTime()
    },
    value: function () {
      this.val = this.value
      this.updateTime()
    }
  },
  methods: {
    updateTime () {
      this.$emit('input', this.val)
    },
  }
}
</script>
